import { useState, useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";
import { getAccessToken } from '../auth/tokenManager';
import { useLocalStorage } from 'usehooks-ts';
const PROFILE_IMAGE = 'PROFILE_IMAGE';
const PROFILE_IMAGE_DATA = 'PROFILE_IMAGE_DATA';

const useProfileData = (fetchProfileImage = true) => {
  const [token, setToken] = useState();
  const [profileImage, setProfileImage] = useLocalStorage(PROFILE_IMAGE, '/DefaultProfile.png');
  const [profileImageData, setProfileImageData] = useLocalStorage(PROFILE_IMAGE_DATA, null);
  const [userName, setuserName] = useState();
  const [userEmail, setuserEmail] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const { instance, accounts } = useMsal();
  const firstAccount = accounts[0];

  useEffect(() => {
    const fetchProfileData = async () => {
      try {
        // User data comes directly from the MSAL account - no token call needed
        // (the axios interceptor in axiosConfig.js handles auth headers automatically)
        setToken(firstAccount.idToken);
        setuserName(firstAccount?.name);
        setuserEmail(firstAccount?.username);
        // TEMP: habilitar acceso a rutas de admin mientras no hay roles reales
        setIsAdmin(true);

        if (fetchProfileImage && profileImageData === null) {
          try {
            const graphToken = await getAccessToken(['User.Read']);
            if (!graphToken) throw new Error('No graph token');
            const graphEndpoint = 'https://graph.microsoft.com/v1.0/me/photo/$value';
            const imageResponse = await fetch(graphEndpoint, {
              headers: {
                Authorization: `Bearer ${graphToken}`,
              },
            });

            if (imageResponse.ok) {
              const blob = await imageResponse.blob();
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = () => {
                setProfileImage(reader.result);
                setProfileImageData({ data: blob });
              };
            }
          } catch (graphError) {
            console.error('Error fetching profile image:', graphError);
            setProfileImage('/DefaultProfile.png');
            setProfileImageData(null);
          }
        }
      } catch (error) {
        console.error('Error in profile data fetch:', error);
        
        // Manejo del error de MFA expirado (AADSTS50078)
        if (error instanceof InteractionRequiredAuthError || 
            (error.errorCode === 'interaction_required') || 
            (error.message && error.message.includes('AADSTS50078'))) {
          
          console.log('MFA expirado. Redirigiendo al flujo de autenticación interactiva...');
          
          instance.acquireTokenRedirect({
            ...loginRequest,
            account: firstAccount
          }).catch(redirectError => {
            console.error('Error al iniciar redirección:', redirectError);
          });
        }
        
        setProfileImage('/DefaultProfile.png');
        setProfileImageData(null);
      }
    };

    if (firstAccount) {
      fetchProfileData();
    }
  }, [instance, firstAccount, fetchProfileImage, profileImageData, setProfileImage, setProfileImageData]);

  return { token, profileImage, userName, userEmail, profileImageData, isAdmin };
};

export default useProfileData;